import React from 'react';
import { Slider } from '../../ui/slider';

export function RefundSlider({ value, onChange }) {
  // Discrete ticks: 0, 10, 15, 20, 25, ..., 90, 95, 100
  const marks = [0, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100];

  const snapToNearest = (val) => {
    return marks.reduce((prev, curr) => 
      Math.abs(curr - val) < Math.abs(prev - val) ? curr : prev
    );
  };

  const handleChange = (newValues) => {
    const snapped = snapToNearest(newValues[0]);
    onChange(snapped);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <label className="text-sm font-medium text-gray-700">Refund Amount</label>
        <div className="text-right">
          <span className="text-2xl font-bold text-gray-900">{value}%</span>
        </div>
      </div>
      
      <Slider
        value={[value]}
        onValueChange={handleChange}
        min={0}
        max={100}
        step={1}
        className="w-full"
        aria-label="Refund percentage"
      />

      <div className="flex justify-between text-xs text-gray-500">
        <span>0%</span>
        <span>25%</span>
        <span>50%</span>
        <span>75%</span>
        <span>100%</span>
      </div>

      <div className="grid grid-cols-3 gap-2">
        <button
          type="button"
          onClick={() => onChange(50)}
          className="px-3 py-1 text-xs border border-gray-300 rounded hover:bg-gray-50"
        >
          50%
        </button>
        <button
          type="button"
          onClick={() => onChange(75)}
          className="px-3 py-1 text-xs border border-gray-300 rounded hover:bg-gray-50"
        >
          75%
        </button>
        <button
          type="button"
          onClick={() => onChange(100)}
          className="px-3 py-1 text-xs border border-gray-300 rounded hover:bg-gray-50"
        >
          100%
        </button>
      </div>
    </div>
  );
}
